import SuggestForPurchaseConstants from '../constants/SuggestForPurchaseConstants';
import SuggestForPurchaseApi from '../api/SuggestForPurchaseApi';
import composeGlobalSuccessMessaging from '../helpers/messaging/composeGlobalSuccessMessaging';
import composeGlobalFailureMessaging from '../helpers/messaging/composeGlobalFailureMessaging';

export function submitLiteSuggestion({ suggestion, postSuccess }) {
  return {
    middlewareData: {
      authRequired: true
    },
    types: [
      SuggestForPurchaseConstants.SUBMIT_LITE_SUGGESTION_REQUEST,
      SuggestForPurchaseConstants.SUBMIT_LITE_SUGGESTION_SUCCESS,
      SuggestForPurchaseConstants.SUBMIT_LITE_SUGGESTION_FAILURE
    ],
    apiRequest: (state, apiClient) => SuggestForPurchaseApi.submitLiteSuggestion(suggestion, apiClient),
    apiSuccess: () => ({
      messaging: composeGlobalSuccessMessaging('suggest_for_purchase_submitted')
    }),
    apiFailure: response => ({
      messaging: composeGlobalFailureMessaging(response.error)
    }),
    postSuccess
  };
}

export default {
  submitLiteSuggestion
};
